/*jshint esversion: 11 */
import axios from 'axios';
const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_HOST_URL,
  timeout: 1000000
});

instance.interceptors.request.use((req) => {
  const access_token = window.localStorage.getItem('ACCESS_TOKEN');
  const user_details = window.localStorage.getItem('user_details');
  if (access_token) {
    req.headers.Authorization = `Bearer ${access_token}`;
  }
  try {
    if (user_details) {
      const parsed_user_details = JSON.parse(user_details);
      const userType = parsed_user_details?.user_type;
      const requestPath = (req.url || '').replace(/^\//, '');
      // Avoid double-prefixing when stale session data exists (e.g. login after logout)
      if (userType && !requestPath.startsWith(`${userType}/`)) {
        req.baseURL = req.baseURL + `/${userType}`;
      }
    }
  } catch (e) {}
  return req;
});

instance.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const msg = err.response?.data?.errors?.[0]?.msg || err.response?.data?.message || '';
    const isSessionExpired = msg.toLowerCase().includes('session expired');

    if ((status === 403 || (status === 400 && isSessionExpired)) && localStorage.getItem('ACCESS_TOKEN')) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default instance;
